<template>
  <div class="icons-list">
    <template v-for="({ icon, title }, keyIcons) in icons">
      <div :key="keyIcons" class="icons-list-item">
        <img
          class="d-block mx-auto icons-list-item-img"
          :src="icon + '?resize=1&h=35'"
          height="35px"
          width="auto"
        />

        <div class="text-center accent--text mt-2">
          <div v-html="title"></div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    icons: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="scss" scoped>
.icons-list {
  display: grid;
  gap: 30px;
  grid-template-columns: repeat(3, 1fr);
}
</style>
